import React from 'react'

import { DirectTask } from '@frame/lib/api/tasks/types'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { isVerifiedTask } from '@frame/lib/utils/tasks'

import { TaskList } from '../../components/task-list'
import { useVerifyTask } from '../../hooks/useVerifyTask'
import { ConnectBankCard } from '../income-only-tasks/connect-bank-card'
import { EmployerHistoryCard } from '../income-only-tasks/employer-history-card'

type Props = {
  tasks: DirectTask[]
}

export function TenantTaskContent({ tasks }: Props) {
  const { bankEnabled, bilEnabledStrategiesNoBank } = useStrategies()
  const { loadingTaskId, handleVerify, handleConnectBank } = useVerifyTask()
  const hideBank = !bankEnabled || tasks.some(isVerifiedTask)
  const isBankOnly = bankEnabled && bilEnabledStrategiesNoBank.length === 0
  const showTaskList = isBankOnly || hideBank

  if (showTaskList) {
    return <TaskList tasks={tasks} loadingTaskId={loadingTaskId} handleVerify={handleVerify} />
  }

  const firstTask = tasks[0]

  return (
    <div className="flex flex-col space-y-4">
      <ConnectBankCard handleConnectBank={() => handleConnectBank(firstTask)} isTenantVerifier />
      <EmployerHistoryCard task={firstTask} handleVerify={handleVerify} isTenantVerifier />
    </div>
  )
}
